export const HUBSPOT_VIDEO_2_TYPE = 'hsvideo2';
export const ADVANCED_VIDEO_OPTIONS = Object.freeze({
  LOOP_VIDEO: 'loop_video',
  MUTE_BY_DEFAULT: 'mute_by_default',
  AUTOPLAY: 'autoplay',
  HIDE_CONTROLS: 'hide_controls'
});